import { dataService } from "../data";
import { DataObject, ObjectOptions } from "./base";

class _ObjectFactory {
    private _registry: Record<
        string, { new (objid: string | null, data: dataService, objoptions: ObjectOptions): DataObject }
    > = {};

    /**
     * Registers a class in the factory registry.
     * @param name - The name of the table or class.
     * @param cls - The class constructor to register.
     */
    register(name: string,cls: { new (objid: string | null, data: dataService, objoptions: ObjectOptions): DataObject }) {
        this._registry[name] = cls;
    }

    /**
     * Retrieves a registered class by name.
     * @param name - The name of the table or class.
     * @returns The class constructor.
     */
    getClass(name: string) {
        return this._registry[name];
    }

    /**
     * Dynamically builds an object based on its table name.
     * @param table - The name of the table.
     * @param objid - The object ID.
     * @param data - The data service.
     * @param objoptions - Additional options for the object.
     * @returns An instance of the corresponding class.
     */
    object(table: string, objid: string | null, data: dataService, objoptions: ObjectOptions = {}): DataObject {
        const _objid = objid == null ? null : String(objid);
        let _object: DataObject | null = null;

        if (_objid && objoptions.storage) {
            _object = objoptions.storage.GetByRef(table, _objid, null) as DataObject;
        }

        if (!_object && data && _objid && !objoptions.volatile) {
            _object = data.store.GetByRef(table, _objid, null) as DataObject;
        }

        if (!_object) {
            const _constructor = this.getClass(table);
            if (_constructor) {
                return new _constructor(_objid, data, objoptions);
            }
        }

        if (!_object){
            throw new Error(`[FACTORY] Cannot create object of table '${table}'`);
        }

        return _object;
    }
}

/**
 * Export a singleton instance of the factory
 */  
export const ObjectFactory = new _ObjectFactory();
